import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Landing from "@/pages/Landing";

export default function AgentLink() {
  const { slug } = useParams();
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/agent/${slug}`)
      .then((r) => setAgent(r.data))
      .catch(() => setAgent(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#111111]">
        <div className="w-10 h-10 border-4 border-[#FFCC00] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return <Landing agent={agent} />;
}
